export enum EscopoVisualizacaoEnum {
  Tudo = 1,
  Proprios = 2,
  Equipe = 3,
}
